export const SETTINGS_PAGE_SUBSCRIPTION: string = 'subscription'
export const SETTINGS_PAGE_WEBHOOKS: string = 'webhooks'
export const SETTINGS_PAGE_WEBHOOK_LOGS: string = 'webhook_logs'
export const SETTINGS_PAGE_MANAGE_ROLES: string = 'manageRoles'
export const SETTINGS_PAGE_WORKFLOWS: string = 'workflows'
export const SETTINGS_PAGE_WORKFLOW_FORM: string = 'workflow_form'

export const SETTINGS_PAGE_NO_BUTTON_SECTIONS: string[] = [
  SETTINGS_PAGE_SUBSCRIPTION,
  SETTINGS_PAGE_WEBHOOK_LOGS,
  SETTINGS_PAGE_MANAGE_ROLES,
  'danger',
  'pipelines',
  'roles',
  'slack',
]

export const USER_ROLE_IDS: { new: string } = {
  new: 'new',
}

export const DEFAULT_TAB_NAME: string = 'space'
